export const UPDATE = 'UPDATE_MAP';

export const UPDATERIDERMAP = 'UPDATE_MAP_RIDER';

export const CLOSE = 'CLOSE_MAP';

export const UPDATE_TO_LOCALSTORAGE = 'UPDATE_MAP_ORDER_TO_LOCALSTORAGE';

export const UPDATE_INVOICE = 'UPDATE_INVOICE';